import { Vue } from 'vue-property-decorator';
import store from '../../../store';
import walletService from '../../../services/walletOrder';
import tableMixin from '../../../Mixins/table';
import formMixin from '../../../Mixins/form';
import { debounce } from 'lodash';
import dateTimeUtil from '../../../utils/dateTime';
export default Vue.extend({
  store,
  mixins: [tableMixin, formMixin],
  data: () => ({
    loading: false,
    order: 'created_at',
    sort: 'desc',
    wallets: [],
    totalWallet: 0,
    totalWalletPages: 0,
    walletPagination: {},
    pageOptions: [10, 25, 50, 100, 200],
    statusOptions: [
      {
        text: 'Pending',
        value: 'pending',
      },
      {
        text: 'Approved',
        value: 'approved',
      },
      {
        text: 'Rejected',
        value: 'rejected',
      },
    ],
    filter: {
      status: [],
      search: null,
    },
    walletHeaders: [
      {
        text: 'Patient Support Pin',
        align: 'center',
        value: 'patient_support_pin',
        sortable: false,
      },
      {
        text: 'Wallet Order ID',
        align: 'center',
        value: 'wallet_order_id',
        sortable: false,
      },
      {
        text: 'Appointment ID',
        align: 'center',
        value: 'appointment_id',
        sortable: false,
      },
      {
        text: 'Created at',
        align: 'center',
        value: 'created_at',
        sortable: true,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'action',
        sortable: false,
      },
      {
        text: 'Method',
        align: 'center',
        value: 'method',
        sortable: false,
      },
      {
        text: 'Amount (THB)',
        align: 'center',
        value: 'total_amount',
        sortable: false,
      },
      {
        text: 'Payment Gateway fee',
        align: 'center',
        value: 'payment_gateway_fee',
        sortable: false,
      },
      {
        text: 'Total Amount (THB)',
        align: 'center',
        value: 'total_amount',
        sortable: false,
      },
      {
        text: 'Voucher code',
        align: 'center',
        value: 'voucher_code',
        sortable: false,
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false,
      },
      {
        text: 'Result Code/Message',
        align: 'center',
        value: 'result_code_message',
        sortable: false,
      },
    ],
  }),
  computed: {
    dateTimeUtil() {
      return dateTimeUtil;
    },
  },
  watch: {
    filter: {
      handler() {
        this.getWalletOrderList().then((data) => {
          this.wallets = data.items;
          this.totalWallet = data.total;
          this.totalWalletPages = data.totalPages;
        });
      },
      deep: true,
    },
    walletPagination: {
      handler() {
        this.getWalletOrderList().then((data) => {
          this.wallets = data.items;
          this.totalWallet = data.total;
          this.totalWalletPages = data.totalPages;
        });
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.getWalletOrderList().then((data) => {
      this.wallets = data.items;
      this.totalWallet = data.total;
      this.totalWalletPages = data.totalPages;
    });
  },
  methods: {
    getWalletOrderList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { page, itemsPerPage } = this.walletPagination;

        let query = {};
        if (itemsPerPage !== -1) {
          query.per_page = itemsPerPage;
          query.page = page;
        }
        query.order = this.order;
        // query.sort = this.sort;
        query.sort = this.walletPagination.sortDesc[0] ? 'asc' : 'desc';
        if (this.filter.search) query.q = this.filter.search;
        if (this.filter.status.length) {
          let filterStatus = [...this.filter.status];
          query.statuses = filterStatus.join(',');
        }

        walletService
          .all(query)
          .then((data) => {
            let items = data.data;
            const meta = data.meta;
            const total = meta.pagination.total;
            const totalPages = meta.pagination.last_page;
            this.loading = false;
            resolve({
              items,
              total,
              totalPages,
            });
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
    refresh() {
      this.getWalletOrderList().then((data) => {
        this.wallets = data.items;
        this.totalWallet = data.total;
        this.totalWalletPages = data.totalPages;
      });
    },
    debounceInput: debounce(function (e) {
      this.filter.search = e;
    }, 500),
  },
  components: {},
});
